
import CloseSvg from '@/components/svg/SvgClose.vue';
import { Swiper, SwiperSlide, /* rest swiper/vue API... */ } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css';
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Swiper,
    CloseSvg,
    SwiperSlide,
  }
})
export default class extends Vue {

  @Prop() showSwiper!: boolean;

  getImgUrl(imgUrl: string) {
    return require('@/assets/img/annual/'+imgUrl+'.jpg')
  }

  swiperOptions: any = {
    effect: 'coverflow',
    grabCursor: true,
    centeredSlides: true,
    slidesPerView: 'auto',
    navigation: { 
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev' 
    },
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      modifier: 1,
      slideShadows : true
    },
    //分页器配置项
    pagination: {
      el: ".swiper-pagination", //分页器的类名
      clickable: true, // 点击分页器跳切换到相应的幻灯片
      type: 'bullets' , // 小圆点
      dynamicBullets: true, // 动态小圆点(type:'bullets'时)
      //自定义分页器，需设置样式
      // renderBullet(index, className) {
      //   return `<span class="${className} swiper-pagination-bullet-custom">${index + 1}</span>`
      // },
    },
  }

  imgUrls = [
    '21_1', '21_2', '21_3',
    '21_4', '21_5',
    '20_1', '20_2', '20_3',
    '19_1', '19_2', '19_3',
    '18_1', '18_2', '18_3',
    '17_1', '16_1', '15_1', '15_2'
  ]

  hideSwiper() {
    this.$emit('hide-swiper');
  }
}
